<template>
    <div class="has-background-primary cart-item__preview">
        <div class="cart-item-control control--delete" v-if="isEditable">
            <div @click="deleteCartItem" class="control__button link">
                <SvgIcon
                    icon="icon--web-application_delete"
                    :grow-by-height="true"
                    class="is-light"
                ></SvgIcon>
                <span class="control__label is-capitalized"
                    >{{ $t('checkout.cart.itemLabels.delete') }}
                </span>
            </div>
        </div>
        <div class="preview__image">
            <img :src="cartItemThumbnail" />
        </div>
        <div class="columns is-desktop is-multiline is-gapless px-2">
            <div class="column">
                <div class="card-item__property">
                    <span class="property__label is-size-5 is-uppercase">{{
                        $t('checkout.cart.itemLabels.priceSingle')
                    }}</span>
                    <template v-if="cartItem.beforeDiscount">
                        <s class="is-5 has-text-danger is-size-6 is-block">{{
                            ((isBusinessCustomer
                                ? cartItem.beforeDiscount.netPrice
                                : cartItem.beforeDiscount.totalPrice) /
                                cartItem.quantity)
                                | toCents
                                | currency
                        }}</s>
                        <h3 class="property__value is-5">
                            {{
                                ((isBusinessCustomer
                                    ? cartItem.pricing.netPrice
                                    : cartItem.pricing.totalPrice) /
                                    cartItem.quantity)
                                    | toCents
                                    | currency
                            }}
                        </h3>
                    </template>
                    <template v-else>
                        <template v-if="cartItem.pricing">
                            <h3 class="property__value is-5">
                                {{
                                    ((isBusinessCustomer
                                        ? cartItem.pricing.netPrice
                                        : cartItem.pricing.totalPrice) /
                                        cartItem.quantity)
                                        | toCents
                                        | currency
                                }}
                            </h3>
                        </template>
                        <template v-else>
                            <h3 class="property__value is-5">
                                {{
                                    (cartItem.priceCents / cartItem.quantity)
                                        | currency
                                }}
                            </h3>
                        </template>
                    </template>
                </div>
            </div>
            <div class="column"></div>
            <div class="column">
                <div class="card-item__property">
                    <span class="property__label is-size-5 is-uppercase">{{
                        $t('checkout.cart.itemLabels.priceSum')
                    }}</span>
                    <template v-if="cartItem.beforeDiscount">
                        <s class="is-5 has-text-danger is-size-6 is-block">{{
                            (isBusinessCustomer
                                ? cartItem.beforeDiscount.netPrice
                                : cartItem.beforeDiscount.totalPrice)
                                | toCents
                                | currency
                        }}</s>
                        <h3 class="property__value is-5">
                            {{
                                (isBusinessCustomer
                                    ? cartItem.pricing.netPrice
                                    : cartItem.pricing.totalPrice)
                                    | toCents
                                    | currency
                            }}
                        </h3>
                    </template>
                    <template v-else>
                        <template v-if="cartItem.pricing">
                            <h3 class="property__value is-5">
                                {{
                                    (isBusinessCustomer
                                        ? cartItem.pricing.netPrice
                                        : cartItem.pricing.totalPrice)
                                        | toCents
                                        | currency
                                }}
                            </h3>
                        </template>
                        <template v-else>
                            {{ cartItem.priceCents | currency }}
                        </template>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { orderProcess } from '../../store/constants/order-process';
import SvgIcon from '../svg/SvgIcon';
import { discountMixin } from '@/mixins/discountMixin';

const API_URL = process.env.VUE_APP_FULFILLMENT_API_BASE_URL;

export default {
    name: 'CartItemPreview',
    components: { SvgIcon },
    mixins: [discountMixin],
    props: {
        cartItem: {
            type: Object,
            required: true,
        },
        isEditable: {
            type: Boolean,
            required: false,
            default: true,
        },
        isLegacy: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        ...mapGetters([
            'printModes',
            'allCartItems',
            'discount',
            'discountApplied',
            'isBusinessCustomer',
            'orderTrackingInfo',
        ]),
        cartItemQuantity: {
            get() {
                return this.$store.getters.cartItemByID(this.cartItem._id)
                    .quantity;
            },
            async set(value) {
                if (this.isEditable) {
                    await this.$store.dispatch('updateCartItemByID', {
                        cartItemID: this.cartItem._id,
                        quantity: value,
                    });
                    await this.$store.dispatch('persistCartItemByID', {
                        cartItemId: this.cartItem._id,
                    });
                }
            },
        },
        cartItemThumbnail() {
            if (this.isLegacy) {
                return this.cartItem.thumbnail;
            }
            return `${API_URL}${this.cartItem.thumbnail}`;
        },
        cartItemPrice() {
            return this.cartItem.currentPrice * this.cartItem.quantity;
        },
        cartItemPiecePrice() {
            return this.cartItem.currentPrice;
        },
    },
    methods: {
        deleteCartItem() {
            let vm = this;
            this.$store
                .dispatch('deleteCartItemByID', {
                    cartItemId: this.cartItem._id,
                })
                .then(() => {
                    if (Object.keys(vm.allCartItems).length < 1) {
                        vm.$store.dispatch(
                            'setCurrentOrderProcessStep',
                            orderProcess.STEPS.NO_ORDER_ONGOING
                        );
                    }
                });
        },
    },
};
</script>
